export default "__VITE_ASSET__s79fJ_W5__"